const siteLanguage = theme?.shop?.language || "english";

const { buttonForgotPasswordTitle, buttonLoginTitle, inputLabelEmail, inputLabelPassword, linkForgotPasswordTitle } = window.theme.login;

console.log("theme site language ::", siteLanguage);

LRObject.$hooks.register("startProcess", function () {
  console.log("LRObject.$hooks :: startProcess...");
  jQuery("#fade").show();
  $("#loading-spinner").show();

  const forgotPasswordElement = document.getElementById("lr-raas-forgot-password");
  if (forgotPasswordElement) forgotPasswordElement.textContent = linkForgotPasswordTitle;
});

LRObject.$hooks.register("endProcess", function (process) {
  console.log("LRObject.$hooks :: endProcess...", process);
  if (!["setToken", "login"].includes(process)) {
    jQuery("#fade").hide();
    $("#loading-spinner").hide();
  }
});

LRObject.$hooks.call("customizeFormPlaceholder", {
  emailid: inputLabelEmail,
  password: inputLabelPassword,
});

LRObject.$hooks.call("customizeFormLabel", {
  emailid: inputLabelEmail,
  password: inputLabelPassword,
});

LRObject.$hooks.call("setButtonsName", {
  forgotpassword: buttonForgotPasswordTitle,
  login: buttonLoginTitle,
});

function setErrorMessage(msg) {
  jQuery("#lr-raas-message").show().addClass("loginradius-raas-error-message").text(msg);
  visibleLoadingSpinner(false);
}

function setMessage(msg) {
  jQuery("#lr-raas-message").show().addClass("loginradius-raas-success-message").text(msg);
  visibleLoadingSpinner(false);
}

function setRaasVisibility(selector, isVisible) {
  var elements = jQuery(selector);
  if (!elements.length) return;

  elements.each(function () {
    this.hidden = !isVisible;
    this.setAttribute("aria-hidden", isVisible ? "false" : "true");
  });

  if (isVisible) {
    elements.show();
    return;
  }

  elements.hide();
}

jQuery(window).load(function () {
  jQuery(".lr_fade").hide();
});

jQuery(".site_login_btn").click(function () {
  jQuery(".account-modal-overlay").show();

  jQuery(".content-loginradius-raas-emailid label").text("Email");

  if (!jQuery(".btn-register").length) {
    var newAccountBtn = '<a class="btn-register" style="float:left;" >New Account</a>';
    jQuery("#login-container form").append(newAccountBtn);
  }

  if (!jQuery("#register-interfacecontainer").length) {
    jQuery("#login-interfacecontainer").clone(true).attr("id", "register-interfacecontainer").appendTo("#social-registration-interface");
  }
});

jQuery(".account-modal-overlay .close-btn img").click(function () {
  jQuery(".account-modal-overlay").hide();
});

LRObject.util.ready(function () {
  window.lr_raas_settings = window.lr_raas_settings || {};

  // Initialize LoginRadius logout if redirected from the checkout information page's "Log Out" link
  const redirectedFromCheckoutUrlParameter = new URLSearchParams(window.location.search).get("checkout_url");

  if (redirectedFromCheckoutUrlParameter && redirectedFromCheckoutUrlParameter.includes("checkouts")) {
    logout_options.onSuccess = function () {};

    if (AuroraServices) AuroraServices.clearCartAttributes();

    lrLogout();
  }

  if (window.lr_raas_settings.registration) {
    registration_options.container = window.lr_raas_settings.registration_containerid;

    LRObject.util.ready(function () {
      LRObject.init("registration", registration_options);
    });
  }

  if (window.lr_raas_settings.login) {
    login_options.container = window.lr_raas_settings.login_containerid;

    LRObject.util.ready(function () {
      LRObject.init("login", login_options);
    });
  }

  if (window.lr_raas_settings.forgotpassword) {
    forgotpassword_options.container = window.lr_raas_settings.forgotpassword_containerid;
    LRObject.init("forgotPassword", forgotpassword_options);
  }

  if (window.location.search.indexOf("vtoken") > -1 && window.location.search.indexOf("vtype=reset") > -1) {
    setRaasVisibility("#lr-raas-login", false);
    setRaasVisibility("#login-container", false);
    setRaasVisibility("#lr-social-traditional-login", false);
    setRaasVisibility("#lr-raas-resetpassword", true);

    if (window.lr_raas_settings.resetpassword) {
      resetpassword_options.container = window.lr_raas_settings.resetpassword_containerid;

      LRObject.init("resetPassword", resetpassword_options);
    }
  }

  if (window.location.search.indexOf("vtoken") > -1 && window.location.search.indexOf("vtype=emailverification") > -1) {
    $("#registration-container").hide();
    $("#lr-raas-message").css("display", "block");
    LRObject.init("verifyEmail", verifyemail_options);
  }

  if (window.lr_raas_settings.sociallogin) {
    raasoption.hashTemplate = true;

    var custom_interface_option = {};
    custom_interface_option.templateName = "loginradiuscustom_tmpl";
    LRObject.util.ready(function () {
      LRObject.customInterface(window.lr_raas_settings.sociallogin_interfaceid, custom_interface_option);
    });

    sl_options.container = window.lr_raas_settings.sociallogin_containerid;
    LRObject.util.ready(function () {
      LRObject.init("socialLogin", sl_options);
    });
  }

  var maxYear = new Date().getFullYear();
  var minYear = maxYear - 100;
  $("body").on("focus", ".loginradius-raas-birthdate", function () {
    $(".loginradius-raas-birthdate").datepicker({
      dateFormat: "mm-dd-yy",
      maxDate: new Date(),
      minDate: "-100y",
      changeMonth: true,
      changeYear: true,
      yearRange: minYear + ":" + maxYear,
    });
  });

  if (getParameterByName("vtype") && getParameterByName("vtype") == "reset" && getParameterByName("vtoken")) {
    jQuery(".account-modal-overlay").show();
  }

  if (getParameterByName("vtype") && getParameterByName("vtype") == "emailverification" && getParameterByName("vtoken")) {
    jQuery(".account-modal-overlay").show();
  }
});

function hideMessage() {
  jQuery("#lr-raas-message").hide();
}

function addJs(url, context) {
  context = context || document;
  var head = context.getElementsByTagName("head")[0];
  var js = context.createElement("script");
  js.src = url;
  js.type = "text/javascript";
  head.appendChild(js);
  return js;
}

function getParameterByName(name) {
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
    results = regex.exec(location.search);
  return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}

function exchangeMultipassToken(lrtoken, handle, path = "/") {
  console.log("[ exchangeMultipassToken() ] :: args...", { lrtoken, handle, path });

  let finalPath = path;

  if (window.location.href.includes("account/login?order=")) {
    let orderId = window.location.href.slice(window.location.href.lastIndexOf("=") + 1);
    finalPath = "/account/orders/" + orderId;
  }

  finalPath = encodeURI(finalPath);

  var url = "https://cloud-api.loginradius.com/sso/shopify/api/token?store=" + lrshopifystore;
  url = url + "&return_url=" + finalPath;

  console.log("[ exchangeMultipassToken() ] :: $.ajax args", {
    lrtoken,
    LoginRadiusApiKey: raasoption.apiKey,
  });

  $.ajax({
    url: url,
    type: "GET",
    dataType: "json",
    headers: {
      Authorization: "Bearer " + lrtoken,
      "X-LoginRadius-ApiKey": raasoption.apiKey,
    },
    success: handle,
    error: function (xhr, status, error) {
      console.log("[ exchangeMultipassToken() ] :: $.ajax error...", { xhr, status, error });
    },
    complete: function (jqXHR, textStatus) {
      console.log("[ exchangeMultipassToken() ] :: $.ajax complete...", { jqXHR, textStatus });
      if (jqXHR.status == 200) {
        window.location = jqXHR.responseJSON.url;
      }
    },
  });
}

/*  ==========================================================================
    SSO Login
============================================================================== */

// If found an active session is found, goto the callback function
var ssologin_options = {};

ssologin_options.onSuccess = function (response) {
  // On Success
  console.log("[ RAAS-Settings ] :: ssologin_options.onSuccess :: response", response);

  // let expiry = new Date(new Date().getTime() + 2*60*60*1000);
  // Cookies.set("_age_validated", true, {expires: expiry});

  let elements = {
    approve: document.querySelector(".js-age-gate-approve"),
    deny: document.querySelector(".js-age-gate-deny"),
    // submit: document.querySelector(".js-age-gate-submit"),
    modal: document.querySelector(".js-age-gate"),
    modalContainer: document.querySelector(".js-age-gate-container"),
  };

  elements.modalContainer.classList.add("is-hidden");
  elements.modal.classList.remove("is-visible");
};

// AURORA - This was required to properly handle login for Shopify.
LRObject.util.ready(function () {
  LRObject.init("ssoLogin", ssologin_options);
});

/*  ==========================================================================
    Login
============================================================================== */

var login_options = {};

login_options.onSuccess = function (response) {
  console.log("[ RAAS-Settings ] :: login_options.onSuccess :: response", response);

  let redirectUrl = undefined;
  let cookie = Cookies.get("_age_validated") == "true";
  // Check for redirect_url URL param
  if (getParameterByName("redirect_url")) {
    redirectUrl = `${getParameterByName("redirect_url")}`;
    redirectUrl = redirectUrl.split("");

    // add slash to front of path
    if (redirectUrl[0] !== "/") {
      redirectUrl.unshift("/");
    }

    redirectUrl = redirectUrl.join("");
  }

  if (!cookie && redirectUrl === undefined && window.location.pathname !== "/") {
    // User is not age validated and URL does not contain redirect_url param
    redirectUrl = window.location.pathname;
  }

  console.log("[ RAAS-Settings ] :: login_options.onSuccess :: exchangeMultipassToken() args...", {
    responseAccessToken: response.access_token,
    redirectUrl: redirectUrl,
  });

  sessionStorage.setItem("cameFromLoginPage", "true");

  // Analytics: mark that a real (interactive) login just succeeded so the GA4
  // `login` event can fire on the authenticated page, where the Shopify
  // customer.id exists (it does not yet — the Shopify session is created by the
  // Multipass redirect below). Read + cleared in snippets/ga-login-event.liquid.
  try {
    localStorage.setItem("aur_login_event", JSON.stringify({ method: "email", t: Date.now() }));
  } catch (e) {}

  exchangeMultipassToken(
    response.access_token,
    function (data) {
      window.location = data.url;
    },
    redirectUrl
  );
};

login_options.onError = function (errors) {
  console.log("[ RAAS-Settings ] :: login_options.onError(errors) :: errors", errors);

  let warningMessage = errors[0].Message;

  if ("french" === siteLanguage) {
    warningMessage = translateErrorMessagesToFrench(warningMessage);
  }

  setErrorMessage(warningMessage);
};

/*  ==========================================================================
    Logout
============================================================================== */

var logout_options = {};

logout_options.onSuccess = function (response) {
  console.log("[ RAAS-Settings ] :: logout_options.onSuccess :: response", { response });

  // On Success
  // Write your custom code here
  console.log("Session not found");
  window.location = "/account/logout";
};

/*  ==========================================================================
    Forgot Password
============================================================================== */

var forgotpassword_options = {};

forgotpassword_options.onSuccess = function (response) {
  document.getElementsByName("loginradius-forgotpassword")[0].reset();
  if ("french" === siteLanguage) {
    setMessage(
      "Les informations de réinitialisation du mot de passe ont été envoyées à l'adresse courriel que vous avez fournie. Veuillez vérifier votre courriel pour plus d'instructions."
    );
  } else {
    setMessage("Password reset information sent to your provided email id, check email for further instructions.");
  }
};

forgotpassword_options.onError = function (errors) {
  console.log("[ RAAS-Settings ] :: forgotpassword_options.onError(errors) :: errors", errors);

  let warningMessage = errors[0].Message;

  if ("french" === siteLanguage) {
    warningMessage = translateErrorMessagesToFrench(warningMessage);
  }

  setErrorMessage(warningMessage);
};

/*  ==========================================================================
    Verify Email
============================================================================== */

var verifyemail_options = {};
verifyemail_options.onSuccess = function (response) {
  setRaasVisibility("#lr-social-traditional-login", false);
  setRaasVisibility("#interfacecontainerdiv", false);
  setRaasVisibility("#no-email-container", true);
  setRaasVisibility("#no-email-container h4", false);

  if ("french" === siteLanguage) {
    setMessage("Courriel vérifié, vous pouvez maintenant vous connecter.");
  } else {
    setMessage("Email verified, now you can login.");
  }
};

verifyemail_options.onError = function (errors) {
  console.log("[ RAAS-Settings ] :: verifyemail_options.onError(errors) :: errors", errors);

  setRaasVisibility("#lr-social-traditional-login", false);
  setRaasVisibility("#interfacecontainerdiv", false);
  setRaasVisibility("#redirectologin", true);

  setErrorMessage(errors[0].Message);
};

/*  ==========================================================================
    Reset Password
============================================================================== */

var resetpassword_options = {};

resetpassword_options.onSuccess = function (response) {
  document.getElementsByName("loginradius-resetpassword")[0].reset();

  setRaasVisibility("#lr-raas-login", true);
  setRaasVisibility("#login-container", true);
  setRaasVisibility("#lr-social-traditional-login", true);
  setRaasVisibility("#resetpassword-container", false);

  if ("french" === siteLanguage) {
    setMessage("Réinitialisation du mot de passe réussie, vous pouvez maintenant vous connecter.");
  } else {
    setMessage("Password reset successfully, now you can login.");
  }

  ga("send", {
    hitType: "event",
    eventCategory: "Reset password",
    eventAction: "Successful",
    eventLabel: "GTM-K32Q5NR",
  });
};

resetpassword_options.onError = function (errors) {
  console.log("[ RAAS-Settings ] :: resetpassword_options.onError(errors) :: errors", errors);

  let warningMessage = errors[0].Message;

  if ("french" === siteLanguage) {
    warningMessage = translateErrorMessagesToFrench(warningMessage);
  }

  setErrorMessage(warningMessage);
};

/*  ==========================================================================
    Registration Options
============================================================================== */

var registration_options = {};
registration_options.onSuccess = function (response) {
  document.getElementsByName("loginradius-registration")[0].reset();

  setMessage("Email for verification has been sent to your provided email, please check email for further instructions");
};

registration_options.onError = function (errors) {
  console.log("[ RAAS-Settings ] :: registration_options.onError(errors) :: errors", errors);

  let warningMessage = errors[0].Message;

  if ("french" === siteLanguage) {
    warningMessage = translateErrorMessagesToFrench(warningMessage);
  }

  setErrorMessage(warningMessage);
};

/*  ==========================================================================
    SL Options
============================================================================== */

var sl_options = {};
sl_options.onSuccess = function (response) {
  console.log("[ RAAS-Settings ] :: sl_options.onSuccess(response) :: response", response);

  //Here you get the access token
  if (response.IsPosted) {
    console.log("[ RAAS-Settings ] :: sl_options.onSuccess(response) :: response is posted?", response.IsPosted);

    document.getElementsByName("loginradius-socialRegistration")[0].reset();
    setMessage("Email for verification has been sent to your provided email, please check email for further instructions");
    setRaasVisibility("#interfacecontainerdiv", false);
  } else {
    console.log("[ RAAS-Settings ] :: sl_options.onSuccess(response) :: response is posted?", response.IsPosted);

    console.log("[ RAAS-Settings ] :: sl_options.onSuccess(response) :: exchangeMultipassToken() args...", {
      responseAccessToken: response.access_token,
    });

    // Analytics: interactive social login just succeeded — mark it for the GA4
    // `login` event (see the email path above and snippets/ga-login-event.liquid).
    // Only the else branch is a real login; the IsPosted branch is social
    // registration awaiting email verification, not a session. method is just
    // "social" — the specific provider isn't reliably on this response; capture it
    // here only once the field is confirmed from the response shape.
    try {
      localStorage.setItem("aur_login_event", JSON.stringify({ method: "social", t: Date.now() }));
    } catch (e) {}

    exchangeMultipassToken(response.access_token, function (data) {
      window.location = data.url;
    });
  }
};

sl_options.onError = function (errors) {
  console.log("[ RAAS-Settings ] :: sl_options.onError(errors) :: errors", errors);

  if (window.isSSORedirectedToken) {
    LRObject.init("logout", logout_options);
  } else {
    setErrorMessage(errors[0].Message);
  }
};

//Account Linking

var la_options = {};
la_options.container = "interfacecontainerdiv";
la_options.templateName = "loginradiuscustom_tmpl_link";
la_options.onSuccess = function (response) {
  console.log(response);
};

la_options.onError = function (errors) {
  console.log(errors);
};

function lrLogout() {
  console.log("[ RAAS-Settings ] :: lrLogout() initialized...");
  console.log("[ RAAS-Settings ] :: lrLogout() logout_options...", { logout_options });

  if (wasRedirectedFromCheckoutSignOut()) {
    console.log("[ RAAS-Settings ] :: lrLogout() :: wasRedirectedFromCheckoutSignOut() :: deleting cart cookie...");
    AuroraUtils.deleteCookie("cart", { path: "/" });
  }

  LRObject.init("logout", logout_options);

  if (getCookie("showLpTransferModal")) {
    eraseCookie("showLpTransferModal");
  }

  if (getCookie("showPrivacyModal")) {
    eraseCookie("showPrivacyModal");
  }
} // lrLogout

$(document).ready(function () {
  if (window.location.pathname == "/logout/account") {
    console.log("window location pathname is '/logout/account'");
    LRObject.init("logout", logout_options);
  }
});

function eraseCookie(key) {
  var keyValue = getCookie(key);
  setCookie(key, keyValue, "-1");
}

function getCookie(key) {
  var keyValue = document.cookie.match("(^|;) ?" + key + "=([^;]*)(;|$)");
  return keyValue ? keyValue[2] : null;
}

function setCookie(key, value, expiry) {
  var expires = new Date();
  expires.setTime(expires.getTime() + expiry * 24 * 60 * 60 * 1000);
  document.cookie = key + "=" + value + ";expires=" + expires.toUTCString();
}

function visibleLoadingSpinner(isvisible = false) {
  if (isvisible) {
    $("#loading-spinner").show();
  } else {
    $("#loading-spinner").hide();
  }
}

function translateErrorMessagesToFrench(message = "") {
  switch (message) {
    case "The Email field is required.": {
      return "Le champ Courriel est obligatoire.";
    }
    case "The Email field must contain a valid email address.": {
      return "Le champ Courriel doit contenir une adresse courriel valide.";
    }
    case "The Password field is required.": {
      return "Le champ Mot de passe est obligatoire.";
    }
    case "Invalid user ID and/or password.": {
      return "Identifiant ou mot de passe invalide.";
    }
    case "User does not exist": {
      return "L'utilisateur n'existe pas.";
    }
    case "Valid email ID is required": {
      return "Un idendifiant email valide est requis.";
    }
    default: {
      return message;
    }
  }
}

LRObject.$hooks.register("beforeFormRender", function () {
  visibleLoadingSpinner(true);
});

LRObject.$hooks.register("afterFormRender", function () {
  visibleLoadingSpinner(false);
});

LRObject.$hooks.register("afterValidation", function (name) {
  console.log("LRObject.$hooks :: afterValidation...", name);
});

function wasRedirectedFromCheckoutSignOut() {
  try {
    const u = new URL(window.location.href);
    if (!u.pathname.includes("/account/login")) return false;
    const checkoutUrl = u.searchParams.get("checkout_url");
    return checkoutUrl != null && checkoutUrl.trim() !== "";
  } catch (e) {
    return false;
  }
}
